import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
    FiDataFieldView_DataField,
    FiDataFieldView_DataFieldObject,
    FiDataFieldViewBase,
} from '../data-field-view-base';
import { ContactService } from '@fi-shared/fi-contacts/contact.service';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { FiContactsService } from '@fi-shared/fi-contacts/fi-contacts.service';
import { IContactModel } from '@fi-shared/models/common';

@Component({
    selector: 'data-field-view-phone-number',
    templateUrl: './phone-number.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewPhoneNumberComponent extends FiDataFieldViewBase {
    constructor(
        @Inject(FiDataFieldView_DataField) dataField: DataFieldModel,
        @Inject(FiDataFieldView_DataFieldObject) dataFieldObject: any,
        public CcmContactService: ContactService,
        private fiContactsService: FiContactsService,
    ) {
        super(dataField, dataFieldObject);
    }

    get isNotEmpty() {
        return this.dataFieldObject.PhoneNumberContacts && this.dataFieldObject.PhoneNumberContacts.length > 0;
    }

    getFullContactValue(contact: IContactModel): string {
        return this.fiContactsService.getFullContactValue(contact);
    }
}
